import fetch from '~/util/fetch';
/* global API_URL */

export default async leagueSlug =>
  fetch(`${API_URL}/${leagueSlug}`)
    .then(response => response.json())
    .catch(() => {});
